import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Geyser2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.GEYSER2;
}

export default Geyser2PoiTileEntity;
